import React from 'react';
import PropTypes from 'prop-types';
import BaseTypography from './Base';

const SmallCopy = ({
  tag = 'p',
  textAlign,
  textTransform,
  color,
  children,
  fontWeight = 'regular',
  fontSize = 'smallCopy',
}) => {
  return (
    <BaseTypography
      tag={tag}
      textAlign={textAlign}
      textTransform={textTransform}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
    >
      {children}
    </BaseTypography>
  );
};

SmallCopy.propTypes = {
  tag: PropTypes.string,
  textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textTransform: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.string,
};

export default SmallCopy;
